import React from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { useJSONFetcher } from "@outplayed/json-fetcher";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { getRoleLabel } from "lib/role_helper";
import { useValidatedChampionProfileParams } from "lib/hooks/championProfileHooks";

const RunesSEO = (props) => {
  const { t } = useTranslation();
  const { getChampionIdByName, getChampionName } = getRiotAssetsContext();
  const { className, page, displayPatch, championId, roleText, rank } = props;
  const envDir = process.env.RIOT_PATCH_ASSETS === "staging" ? "staging" : "prod";
  const {
    data: seoNames,
    loading: loadingSEONames,
    error: errorSEONames,
  } = useJSONFetcher(`https://static.bigbrain.gg/assets/lol/riot_patch_update/${envDir}/seo-champion-names.json`, { ssr: true });
  const { validatedParams } = useValidatedChampionProfileParams(championId, "runes", { keepDefaultParams: true, ssr: true });

  if (loadingSEONames || errorSEONames) {
    return null;
  }

  const { name, altName, altName2 } = seoNames[championId];
  const champ1 = name;
  const champ2 = altName || name;
  const oppChampionName = getChampionName(getChampionIdByName(validatedParams.opp)) || "All Champions";

  let blurb = t("Runes blurb", {
    champ1: champ1,
    champ2: champ2,
    role: getRoleLabel(roleText),
    patch: displayPatch,
    matchup: "vs " + oppChampionName,
  });

  return <div className={classnames("seo-fluff", className)}>{blurb}</div>;
};

export default RunesSEO;
